<template>
    <div class="body">
        <div class="top">
            <img class="t_left" :src="webImg + userInfo.avatar" />
            <div class="t_right">
                <div class="tr_left">
                    <div>你好，{{ userInfo.name || '' }}同学。欢迎登录七米课堂助手</div>
                    <div>完成以下课堂助手</div>
                </div>
                <div class="tr_right">
                    <img title="刷新" src="@/assets/img/s4.png" @click="btn_sx" />
                    <img title="退出" src="@/assets/img/s5.png" @click="btn_out" />
                </div>
            </div>
        </div>
        <div class="bottom">
            <div class="b_item" @click="btn_item(item)" v-for="(item, index) in list" :key="index"
                :style="{ background: colorList[index % 9] + ' !important' }">
                <div class="bi_left">
                    <div class="bil_top line1_">{{ item.name }}</div>
                    <div class="bil_bottom">
                        点击查看详情
                        <img src="@/assets/img/s6.png" />
                    </div>
                </div>
                <img class="bi_right" :src="webImg + item.icon" />
            </div>
        </div>
    </div>
</template>

<script>
import {
    classroomTestList,
    classroomTestStatusStu
} from '@/apis/index'
export default {
    data() {
        return {
            colorList: [
                'linear-gradient( 233deg, #FD7D72 0%, #FE685B 100%)',
                'linear-gradient( 227deg, #61A1FF 0%, #1883FF 100%)',
                'linear-gradient( 220deg, #FBB9F6 0%, #F793EB 100%)',
                'linear-gradient( 233deg, #70E4A4 0%, #52D589 100%)',
                'linear-gradient( 233deg, #FCBE85 0%, #FBA769 100%)',
                'linear-gradient( 233deg, #6DE0E1 0%, #54D6D4 100%)',
                'linear-gradient( 233deg, #9278FD 0%, #896DFE 100%)',
                'linear-gradient( 233deg, #FFA736 0%, #FFA01C 100%)',
                'linear-gradient( 230deg, #A6DA4A 0%, #7EC42C 100%)'
            ],
            list: [],
            userInfo: JSON.parse(sessionStorage.getItem('userInfos')) || JSON.parse(localStorage.getItem('userInfo')) || {},
            flag: false
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        btn_sx() {
            classroomTestList().then(res => {
                console.log(res, 'classroomTestList');
                this.list = res.data
                this.$message.success('刷新成功')
            })
        },
        btn_out() {
            if(sessionStorage.getItem('token')){
                sessionStorage.clear();
                this.$router.replace('/logins?activeName=student')
            }else{
                localStorage.removeItem('token')
                this.$router.replace('/login?activeName=student')
            }
        },
        btn_item(item) {
            if (this.flag) {
                return false;
            }
            this.flag = true;
            classroomTestStatusStu(item.id).then(res => {
                console.log(res, 'classroomTestStatusStu');
                var status = res.data;
					if (status == 0) {
						if (item.name == '出题助手'||item.type == 4) {
                            this.$message.console.error('PC端暂不支持出题助手');
						} else {
                            this.$router.push({ path: '/student/studentIntelligentBodyDialogue', query: { techClassHelperId: item.techClassHelperId } })
						}
					} else {
						this.$message.console.error('当前智能体尚未启用');
					}
            }).finally(() => {
                this.flag = false;
            });
        },
        getList() {
            classroomTestList().then(res => {
                console.log(res, 'classroomTestList');
                this.list = res.data;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.line1_ {
    word-break: break-all;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

.body {
    width: 100%;
    height: 100vh;
    background: #F3F5FA;
    box-sizing: border-box;
    padding: 40px 5%;
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;

    .top {
        width: 100%;
        display: flex;
        align-items: center;

        .t_left {
            width: 120px;
            height: 120px;
            border-radius: 20px;
            border: 3px solid #FFFFFF;
        }

        .t_right {
            flex: 1;
            margin-left: 40px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .tr_left {

                div:nth-child(1) {
                    font-weight: bold;
                    font-size: 32px;
                    color: #000000;
                }

                div:nth-child(2) {
                    font-weight: 400;
                    font-size: 20px;
                    color: #386F8C;
                    margin-top: 30px;
                }
            }

            .tr_right {
                display: flex;
                align-items: center;

                img {
                    width: 80px;
                    height: 80px;
                    margin-left: 30px;
                    cursor: pointer;
                }
            }
        }
    }

    .bottom::-webkit-scrollbar {
        display: none;
    }

    .bottom {
        width: 100%;
        height: 0;
        flex: 1;
        display: flex;
        align-items: center;
        align-content: flex-start;
        flex-wrap: wrap;
        margin-top: 40px;
        overflow-y: scroll;

        .b_item {
            width: 31.3%;
            height: 160px;
            border-radius: 20px;
            box-sizing: border-box;
            padding: 0px 40px;
            display: flex;
            align-items: center;
            // margin-right: 1.3%;
            margin: 0 1%;
            margin-bottom: 1.7%;

            .bi_left {
                flex: 1;
                margin-right: 30px;

                .bil_top {
                    width: 100%;
                    font-weight: bold;
                    font-size: 24px;
                    color: #FFFFFF;
                }

                .bil_bottom {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    font-weight: 400;
                    font-size: 16px;
                    color: #FFFFFF;
                    cursor: pointer;
                    margin-top: 20px;

                    img {
                        width: 30px;
                        height: 30px;
                        margin-left: 20px;
                    }
                }
            }

            .bi_right {
                width: 90px;
                height: 90px;
                border-radius: 15px;
                border: 3px solid #FFFFFF;
            }
        }
    }
}
</style>